import { Component, Inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ShopSettingsRepository } from '@infrab4a/connect';
import { ConfirmationService, MessageService } from 'primeng/api';
import { CustomizationComponent } from 'src/app/components/customization/customization.component';
import {
  Campaign,
  CampaignsDocument,
  CampaignsUpdatePayload
} from './glam-campaigns.models';

@Component({
  selector: 'app-glam-campaigns',
  templateUrl: './glam-campaigns.component.html',
  styleUrls: ['./glam-campaigns.component.scss']
})
export class GlamCampaignsComponent
  extends CustomizationComponent
  implements OnInit
{
  pageDocument: CampaignsDocument;
  pageCampaigns: Campaign[];

  constructor(
    override router: Router,
    @Inject('ShopSettingsRepository')
    private shopSettingsRepository: ShopSettingsRepository,
    private messageService: MessageService,
    private confirmationService: ConfirmationService
  ) {
    super(router);

    this.documentId = 'CAMPANHAS';
    this.newCampaignPage = 'configuracoes/glam/campaigns/new';
    this.editCampaignPage = 'configuracoes/glam/campaigns/edit/';
  }

  async ngOnInit(): Promise<void> {
    await this.getDocument();
  }

  override async getDocument(): Promise<void> {
    try {
      this.pageDocument = (await this.shopSettingsRepository.get({
        id: this.documentId
      })) as CampaignsDocument;
    } catch (error) {
      this.pageDocument = {
        id: this.documentId,
        campaigns: []
      } as CampaignsDocument;
    }

    this.normalizeDocument(this.pageDocument);
    this.pageCampaigns = this.pageDocument.campaigns;
  }

  override async onReorder(): Promise<void> {
    const payload: CampaignsUpdatePayload = {
      id: this.documentId,
      campaigns: this.pageCampaigns
    };

    await this.shopSettingsRepository.update(payload);
    this.pageDocument.campaigns = this.pageCampaigns;

    this.messageService.add({
      severity: 'success',
      summary: 'Campanhas alteradas',
      detail: 'A ordenação foi alterada com sucesso!'
    });
  }

  override async deleteSection(campaign: Campaign): Promise<void> {
    this.confirmationService.confirm({
      acceptLabel: 'Sim',
      acceptButtonStyleClass: 'p-button-danger',
      rejectLabel: 'Não',
      rejectButtonStyleClass: 'p-button-primary',
      message: 'Tem certeza que deseja excluir?',
      header: 'Atenção!',
      accept: async () => {
        this.pageCampaigns = null;
        const index = this.pageDocument.campaigns?.findIndex(
          (currentCampaign) => currentCampaign === campaign
        );

        if (index >= 0) {
          this.pageDocument.campaigns.splice(index, 1);
        }

        const payload: CampaignsUpdatePayload = {
          id: this.documentId,
          campaigns: this.pageDocument.campaigns
        };

        await this.shopSettingsRepository.update(payload);

        this.messageService.add({
          severity: 'success',
          summary: 'Campanha excluída',
          detail: 'A campanha foi excluída com sucesso!'
        });

        this.pageCampaigns = this.pageDocument.campaigns || [];
      },
      reject: () => {
        this.pageCampaigns = this.pageDocument.campaigns || [];
      }
    });
  }

  goToNewScreen() {
    this.navigate(this.newCampaignPage);
  }

  goToEditScreen(campaign: Campaign) {
    const index = this.pageCampaigns.indexOf(campaign);
    this.navigate(`${this.editCampaignPage}${index}`);
  }

  private normalizeDocument(document: CampaignsDocument): void {
    document.campaigns = Array.isArray(document?.campaigns)
      ? document.campaigns
      : [];
  }
}
